import { render, staticRenderFns } from "./customer_balance_sheet.vue?vue&type=template&id=b84d5016&scoped=true&"
import script from "./customer_balance_sheet.vue?vue&type=script&lang=js&"
export * from "./customer_balance_sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d5016",
  null
  
)

export default component.exports